import { render, staticRenderFns } from "./CmgLoyaltyBannerRewardsPage.vue?vue&type=template&id=3c537816&scoped=true&lang=pug&"
import script from "./cmg-loyalty-banner-rewards-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-loyalty-banner-rewards-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgLoyaltyBannerRewardsPage.vue?vue&type=style&index=0&id=3c537816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c537816",
  null
  
)

export default component.exports